import React, {Component} from "react";
import PropTypes from "prop-types";
import {Card} from "react-bootstrap";
import "../Elements/FromGroup/form_select.css"
import AscModal from "../Elements/Modal/Modal";
import {EditProperNounHints} from "../Elements/AscElements/ProperNounElements";


export default class ProperNounInsertModal extends Component {
    render() {
        return (
            <AscModal
                state={this.props.state}
                propSetState={this.props.propSetState}
                langText={this.props.langText}
                validationHandle={this.props.validationHandle}
                onClick={this.props.onClick}
                getTokenCount={this.props.getTokenCount}>
                <Card variant="info">
                    <Card.Header>
                        <Card.Title>
                            {this.props.langText.Body.ProperNounInfo}
                        </Card.Title>
                    </Card.Header>

                    <Card.Body>
                        <EditProperNounHints
                            state={this.props.state}
                            langText={this.props.langText}
                            onTextChange_Limit = {this.props.onTextChange_Limit}    
                            getTokenCount={this.props.getTokenCount}
                            charaLimit = {this.props.charaLimit}>
                        </EditProperNounHints>
                    </Card.Body>
                </Card>
            </AscModal>
        );
    }
}

ProperNounInsertModal.propTypes = {
    state: PropTypes.object.isRequired,
    langText: PropTypes.object.isRequired,
    charaLimit: PropTypes.object.isRequired,
    onClick: PropTypes.func.isRequired,
    validationHandle: PropTypes.func.isRequired,
    onTextChange_Limit: PropTypes.func.isRequired,
    getTokenCount: PropTypes.func.isRequired,
    propSetState: PropTypes.func,
};
